import { Component, OnInit } from '@angular/core';
import { HeatMapService } from '../heatmap.service';
import { Observable, empty } from 'rxjs';



declare function initMap(): any;

export interface HeatmapData {

  subdivision_name: string, 
  street_address: string, 
  schedule_date: string, 
  region: string

}



@Component({
  selector: 'app-heatmap',
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.css']
})

export class HeatmapComponent implements OnInit {
/*
  center: 0;
  title = 'Charlotte Subdivisions';
  markerPositions: google.maps.LatLngLiteral[] = [];
*/
  
  constructor( private heatmapService: HeatMapService){}

  heatmap$ : Observable<any>

  ngOnInit() {
    

      this.heatmap$ = this.heatmapService.getHeatmapData().pipe();

/*
      this.heatmapService.getHeatmapData().subscribe(
          res => {
                //data will be in res. 
                this.heatmap = res.HeatmapData;

          },err => {
          }
        )
*/


  }

  
}